import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';

export const FilterSearchEmpty = ({
  title,
  description,
  isSizeSmall = false,
  moduleName = '',
  isFromMoments = false
}: {
  title?: string;
  description?: string;
  isSizeSmall?: boolean;
  moduleName?: string;
  isFromMoments?: boolean;
}) => {
  const { t } = useTranslation();
  // const containerRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   containerRef.current?.scrollIntoView({
  //     behavior: 'smooth',
  //     block: 'center'
  //   });
  // }, []);

  return (
    <div
      className={`flex items-center justify-center ${isFromMoments ? 'min-h-[5vh]' : 'min-h-[60vh]'}`}>
      <div className="text-center max-w-md lg:max-w-lg px-6">
        <div className="flex justify-center mb-2">
          <SVGAssets.FilterEmpty
            className={isSizeSmall ? 'w-28 h-28' : 'w-72 h-72'}
          />
        </div>
        {!isSizeSmall ? (
          <>
            <h2
              className="text-xl font-semibold text-[#353535] mb-4"
              // ref={containerRef}
            >
              {title || t('folderEmpty.title')}
            </h2>
            <p className="text-sm text-[#505050] leading-relaxed mb-6">
              {description || t('folderEmpty.desc')}
            </p>
          </>
        ) : isFromMoments ? (
          <>
            <h6 className="text-xl font-semibold text-[#353535]">
              {title || t('folderEmpty.title')}
            </h6>
            <p className="text-sm text-[#505050] leading-relaxed mb-1">
              {description || t('folderEmpty.desc')}
            </p>
          </>
        ) : (
          <p className="text-sm text-[#505050] leading-relaxed mb-3">
            {t('noDataAvailable', { module: moduleName })}
          </p>
        )}
      </div>
    </div>
  );
};
